import { DateTime } from 'luxon';
import { ApplicationDurationType } from '../types/application-duration.type';

export function getApplicationDurationDays(travelStartDate: Date | string, travelEndDate: Date | string): number {
    const startDate = DateTime.fromJSDate(new Date(travelStartDate)).startOf('day');
    const endDate = DateTime.fromJSDate(new Date(travelEndDate)).startOf('day');
    return endDate.diff(startDate, 'days').days;
}

export function getApplicationOvernightStays(
    travelStartDate: Date | string,
    travelEndDate: Date | string
): number | null {
    const days = getApplicationDurationDays(travelStartDate, travelEndDate);

    if (Number.isNaN(days) || days < 0) {
        return null;
    }

    return Math.round(days);
}

export function getApplicationDurationType(
    travelStartDate: Date | string,
    travelEndDate: Date | string
): ApplicationDurationType {
    const startDate = DateTime.fromJSDate(new Date(travelStartDate)).startOf('day');
    const endDate = DateTime.fromJSDate(new Date(travelEndDate)).startOf('day');
    const overnights = endDate.diff(startDate, 'days').days;

    return overnights > 13 ? 'LONG' : 'SHORT';
}
